import React, {Component} from 'react';



class CalendarCell extends Component {



    isInRange(d) {
        if (d.TDate > this.props.startDay && d.TDate < this.props.endDay) {
            return true;
        } else {
            return false;
        }            
    }


    isCellType = (d) => {
        if ( this.props.startDay != null) {
            if (d.TDate.getTime() === this.props.startDay.getTime()) {
                if ( this.props.endDay === null) {
                    return 1;
                } else {
                    return 2;
                }
            }
        }

        if ( this.props.endDay != null) {
            if (d.TDate.getTime() === this.props.endDay.getTime()) {
                return 3;
            }
        }

        return 4;
    }




    getCssClass(d) {

        if (d.selected) {
            return "calendar_day_current_circle ponter";
        }

        if (this.isInRange(d) ) {
            return "calendar_day_in_range ponter";
        } else {
            return "calendar_day_enable";
        }
    }

    setDayCell(d) {
        console.log('CalendarCell  setSelectedDate', d);
       this.props.setDayCell(d);

       
    }



render() { 

    return (
        <React.Fragment>

                {(this.isCellType(this.props.d) === 1) 
                ? 
                <div key={this.props.d.key} 
                    className="calendar_day_current_circle"  
                    onClick={() => this.setDayCell(this.props.d)} >{this.props.d.thisDay}
                </div>
                : null}


                {(this.isCellType(this.props.d) === 2) 
                ? 
                <div key={this.props.d.key} 
                    className="calendar_day_in_range_start" 
                    onClick={() => this.setDayCell(this.props.d)} >
                    <div className="calendar_day_current_circle">{this.props.d.thisDay}</div>
                </div>
                 : null}


                {(this.isCellType(this.props.d) === 3) 
                ? 
                <div key={this.props.d.key} 
                    className="calendar_day_in_range_end" 
                    onClick={() => this.setDayCell(this.props.d)} >
                    <div className="calendar_day_current_circle">{this.props.d.thisDay}</div>
                </div>
                : null}

                {(this.isCellType(this.props.d) === 4) 
                ? 
                <div key={this.props.d.key} 
                    className={this.getCssClass(this.props.d)}  
                    onClick={() => this.setDayCell(this.props.d)} >{this.props.d.thisDay}
                </div>
                : null}
        </React.Fragment>
    )
  }
}

export default CalendarCell;
//export  default connect()(Calendar)